import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { MeetingRoomAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";
import React, { useMemo } from "react";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions' | 'onChange'> {
    onChange: (items: MeetingRoomAutoCompleteDataModel[]) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de locais de treinamentos.
 * @param props
 */
const MeetingRoomAutoCompleteComponent: React.FC<Props> = ({ onChange, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<MeetingRoomAutoCompleteDataModel>>((resolve) => {
            api.v1.lmsSuggestions.meetingRooms({
                searchText,
                pageNumber,
                pageSize,
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as MeetingRoomAutoCompleteDataModel[],
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return useMemo(() => (
        <MprcAutoComplete
            {...props}
            freeSolo
            placeholder={props.selectedItems.length > 0 ? "" : props.placeholder}
            disabledInput={props.disabled || props.selectedItems.length > 0}
            onError={onError}
            onGetSuggestions={getSuggestions}
            onChange={items => onChange(items as MeetingRoomAutoCompleteDataModel[])}
        />
    ), [props.selectedItems, props.startInputValue]);
};

export const MeetingRoomAutoComplete = React.memo(MeetingRoomAutoCompleteComponent, (prev, next) => {
    return prev.selectedItems == next.selectedItems
        && prev.startInputValue == next.startInputValue;
});